module.exports = __webpack_public_path__ + "img/Bitlayer.a85dd7f1.png";